module.exports = "/_next/static/images/4aceaf86a9a5a9fb26a377a2bff851d1-nubanker-bizarch@0.5x.jpg.webp";